import { Avatar } from '@mui/material'
import { C1DisplayNameSkeleton, DisplayNameDetails } from 'components/core/display-name-details'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { MinimalAPIError } from 'components/core/errors/api'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Webhook as WebhookIcon } from 'lucide-react'
import { Webhook, WebhooksServiceGetRequest } from 'pbts/c1/api/webhooks/v1/webhooks'
import { FormattedMessage } from 'react-intl'
import { getWebhookApi } from 'redux_toolkit/webhooks'

export type C1WebhookDisplayProps = {
  webhook: Webhook | undefined
  readOnly?: boolean
  maxWidth?: string,
  padded?: boolean
  margin?: boolean
}

export const C1WebhookDisplayWithFetch: React.FC<Omit<C1WebhookDisplayProps, 'webhook'> & { id: string}> = ({
    id, ...rest
}) => {
    const actionable = !!id
    const { data, isError, error, isLoading } = getWebhookApi.useGet(WebhooksServiceGetRequest.create({ id }), { actionable })

    if (isLoading) return <C1DisplayNameSkeleton />

    if ((isError && error) || !data) {
        const err = <FormattedMessage id="component_api_error_webhook" defaultMessage="Error fetching webhook" />
        return <MinimalAPIError err={err} />
    }

    return <C1WebhookDisplay webhook={data.webhook} {...rest} />
}

export const greyIconAvatarSx = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.primary',
    backgroundColor: 'background.default',
    verticalAlign: 'middle',
    height: 24,
    width: 24,
}

export const C1WebhookDisplay: React.FC<C1WebhookDisplayProps> = ({
    webhook, maxWidth, margin = false, padded = false,
}) => {
    if (!webhook) return <C1EmptyIndicator message={<FormattedMessage defaultMessage="Webhook not found" id="component_webhook_not_found" />} />

    return <DisplayNameDetails
        avatar={<Avatar sx={greyIconAvatarSx}>
            <C1Icon icon={WebhookIcon} sx={{ color: 'info.main' }} />
        </Avatar>}
        displayName={webhook.displayName}
        details={webhook.url}
        margin={margin}
        padded={padded}
        readOnly
        maxWidth={maxWidth}
    />
}
